import { useEffect, useState } from "react";
import { getComparisonRunScoringConfigById } from "../services/scoringService";

const useFetchComparisonRunScoringConfigById = ({
  setIsLoading,
  configId,
}: any) => {
  const [configData, setConfigData] = useState<any>({});

  useEffect(() => {
    if (configId && configId > 0) {
      setIsLoading(true);
      const fetchData = async () => {
        try {
          const result = await getComparisonRunScoringConfigById(configId);
          // The service catches errors internally and returns undefined on failure.
          // Guard against undefined/null so we never overwrite valid state with nothing.
          // Also handle the case where the endpoint returns a list instead of a single
          // object (the URL is shared with getComparisonRunScoringConfigsForRun).
          if (Array.isArray(result)) {
            const found =
              result.find((item: any) => item.id === configId) || result[0];
            if (found) setConfigData(found);
          } else if (result) {
            setConfigData(result);
          }
          // If result is undefined/null the state stays as {} — the caller
          // must fall back to location.state?.rowData or show an error.
        } catch (err) {
          setConfigData({});
        } finally {
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [configId]);

  return [configData];
};

export default useFetchComparisonRunScoringConfigById;
